import React, { Component } from "react"
import { Container, Row, Col } from "reactstrap"

import LeadsListHeader from "./LeadsListHeader"
import LeadsList from "./LeadsList"
import ListingTabs from "../Material/ListingTabs"
import ReportsPanel from "../Reports/ReportsPanel"
import withApolloClient from "../withApolloClient"
import { buildPresets } from "../Filters/presetFilters"

const TABS = {
    applicationView: [{ id: "#applications", name: "New Applications", iconClassName: "fa fa-user-o" }],
    leadView: [
        { id: "#open", name: "Open", iconClassName: "fa fa-user-o" },
        { id: "#review", name: "Need Review", iconClassName: "fa fa-wpforms" },
        { id: "#didnttakecar", name: "Didn't Take a Car", iconClassName: "fa fa-low-vision" },
        { id: "#dnr", name: "DNR", iconClassName: "fa fa-ban" },
        { id: "#all", name: "All Leads", iconClassName: "fa fa-handshake-o" },
        { id: "#reports", name: "Activity Log", iconClassName: "fa fa-history", floatRight: true, iconOnly: true },
    ]
}
const LEAD_TAB_PRESET_FILTERS = {
    "#applications": [
        { fieldName: "status", filterType: "equal", filterValues: ["Onboarding"], editable: false, visible: false },
        { fieldName: "is_archived", filterType: "equal", filterValues: "false", editable: false, visible: false },
    ],
    "#open": [
        { fieldName: "status", filterType: "in", filterValues: ["Open", "Contacted"], editable: false, visible: false },
        { fieldName: "is_archived", filterType: "equal", filterValues: "false", editable: false, visible: false },
    ],
    "#review": [
        { fieldName: "status", filterType: "equal", filterValues: ["Need Review"], editable: false, visible: false },
        { fieldName: "is_archived", filterType: "equal", filterValues: "false", editable: false, visible: false },
    ],
    "#didnttakecar": [
        { fieldName: "status", filterType: "equal", filterValues: ["Canceled"], editable: false, visible: false },
    ],
    "#dnr": [
        { fieldName: "is_blocked", filterType: "equal", filterValues: "true", editable: false, visible: false },
        { fieldName: "is_archived", filterType: "equal", filterValues: "false", editable: false, visible: false },
    ],
}

export const getPresetsForTab = (tabId) => buildPresets(LEAD_TAB_PRESET_FILTERS[tabId] || [])

const tableHeaders = [
    { id: "date_added", name: "Date Added", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true }, view: ["applicationView", "leadView"] },
    { id: "id", name: "Lead Info", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: false, canReorder: false }, view: ["applicationView", "leadView"] },
    { id: "status", name: "Status", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true }, view: ["leadView"] },
    { id: "missing_docs", name: "Required Application Docs", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true }, view: ["applicationView", "leadView"] },
    { id: "notes", name: "Notes", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true }, view: ["applicationView", "leadView"] },
    { id: "branch", name: "Applied Branch", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true }, view: ["applicationView", "leadView"] },
    { id: "tags", name: "Driver Tags", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true }, view: ["applicationView", "leadView"] },
    { id: "assigned_to", name: "Assigned To", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true }, view: ["applicationView", "leadView"] },
]

const getDefaultColumnConfig = (viewType) => (
    tableHeaders
        .filter((column) => column.view.includes(viewType))
        .map((column, index) => ({
            ...column,
            order: index,
        }))
)
class LeadsListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tabs: this.props.viewType === "applicationView" ? TABS["applicationView"] : TABS["leadView"],
            filterValues: {
                orderBy: ["-customer__in_office", "-date_added"],
            },
            refetchLeads: false,
            selectedLeads: [],
            activeTab: null,
            columnConfig: getDefaultColumnConfig(props.viewType),
            presets: [],
            defaultPresets: [],
        }
    }

    setColumnConfig = (columnConfig) => {
        this.setState({ columnConfig })
    }

    setPresets = (presets) => this.setState({ presets, selectedLeads: [] })

    updateOrder = (string) => {
        let order = [...this.state.filterValues.orderBy]
        if (!order.includes(string) && !order.includes("-" + string)) {
            order = [order.find(item => item.includes("-customer__in_office")), string]
        } else {
            let index = order.indexOf(string)
            if (order.indexOf(string) > -1) {
                order[index] = "-" + string
            } else {
                index = order.indexOf("-" + string)
                index > -1 && (order[index] = string)
            }
        }
        this.setState({ filterValues: { ...this.state.filterValues, orderBy: order } })
    }

    changeTab = (value) => {
        let activeTab = this.state.tabs.find(item => item.id === value)

        if (!activeTab) return

        if (value !== this.state.activeTab) {
            window.location.hash = activeTab.id

            let { searchTerm, ...updatedFilterValues } = this.state.filterValues
            const nextPresets = getPresetsForTab(activeTab.id)

            this.setState({
                activeTab: activeTab.id,
                filterValues: updatedFilterValues,
                presets: nextPresets,
                defaultPresets: nextPresets,
            })
        }
    }


    componentDidMount() {
        let defaultTab = this.state.tabs[0]
        if (window.location.hash && this.state.tabs.map(item => item.id).includes(window.location.hash)) {
            const activeTab = this.state.tabs.find(item => item.id === window.location.hash).id
            const presets = getPresetsForTab(activeTab)
            this.setState({ activeTab, selectedLeads: [], presets, defaultPresets: presets })
        } else {
            const presets = getPresetsForTab(defaultTab.id)
            window.location.hash = defaultTab.id
            this.setState({ activeTab: defaultTab.id, selectedLeads: [], presets, defaultPresets: presets })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.viewType !== this.props.viewType) {
            let relatedTabs = this.props.viewType === "applicationView" ? TABS["applicationView"] : TABS["leadView"]
            const presets = getPresetsForTab(relatedTabs[0].id)
            this.setState({ tabs: relatedTabs, activeTab: relatedTabs[0].id, selectedLeads: [], filterValues: { orderBy: ["-customer__in_office", "-date_added"] }, columnConfig: getDefaultColumnConfig(this.props.viewType), presets, defaultPresets: presets })
            window.location.hash = relatedTabs[0].id
        }
    }

    render() {
        return (
            <Container fluid className="bos-listing-container">
                {this.state.tabs && this.state.tabs.length > 1 && (
                    <ListingTabs tabs={this.state.tabs} activeTab={this.state.activeTab} onChange={this.changeTab} />
                )}
                {this.state.activeTab !== "#reports" && <LeadsListHeader
                    filterValues={this.state.filterValues}
                    setFilterValues={(filterValues) => this.setState({ filterValues })}
                    selectedLeads={this.state.selectedLeads}
                    activeTab={this.state.activeTab}
                    resetSelectedLeads={() => this.setState({ selectedLeads: [] })}
                    currentUser={this.props.currentUser} location={this.props.location} history={this.props.navigate}
                    refetchQuery={() => this.setState({ refetchLeads: !this.state.refetchLeads })}
                    tableId={this.props.viewType === "leadView" ? "lead" : "application"}
                    columnConfig={this.state.columnConfig}
                    setColumnConfig={this.setColumnConfig}
                    defaultColumnConfig={getDefaultColumnConfig(this.props.viewType)}
                    presets={this.state.presets}
                    setPresets={this.setPresets}
                    defaultPresets={this.state.defaultPresets}
                />}
                <Row>
                    <Col>
                        {this.state.activeTab === "#reports" ? (
                            <ReportsPanel reportId="leads" />
                        ) : 
                        this.state.activeTab && 
                            <LeadsList
                                key={String(this.state.refetchLeads)}
                                orderBy={this.state.filterValues && this.state.filterValues.orderBy ? this.state.filterValues.orderBy : null}
                                updateOrder={this.updateOrder}
                                columnConfig={this.state.columnConfig}
                                currentUser={this.props.currentUser}
                                viewType={this.props.viewType || ""}
                                searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                                statuses={this.props.viewType === "applicationView" ? ["Onboarding"] : this.state.activeTab === "#open" ? ["Open", "Contacted"] : this.state.activeTab === "#review" ? ["Need Review"] : this.state.activeTab === "#didnttakecar" ? ["Canceled"] : []}
                                presets={this.state.presets}
                                selectedLeads={this.state.selectedLeads}
                                setSelectedLeads={(selectedLeads) => this.setState({ selectedLeads })}
                                refetchLeads={this.state.refetchLeads}
                                setRefetchQuery={() => this.setState({ refetchLeads: !this.state.refetchLeads })}
                            />
                        }
                    </Col>
                </Row>
            </Container>
        )
    }
}


export default withApolloClient(LeadsListContainer)
